<div class="container" fxLayout="column" fxLayoutGap="16px">
  <h2>クーポン[新規作成]</h2>
  <mat-form-field *ngIf="race">
    <mat-label>大会名</mat-label>
    <input matInput [value]="race.title" disabled>
  </mat-form-field>

  <mat-form-field>
    <mat-label>タイトル</mat-label>
    <input matInput maxlength="{{maxLengthTitle}}" [formControl]="title">
    <mat-hint align="end">{{ title.value?.length || 0 }}/{{ maxLengthTitle }}</mat-hint>
    <mat-error *ngIf="title.hasError('required')">
      タイトルを入力してください。
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>説明文</mat-label>
    <textarea matInput [formControl]="description" rows="5"
              maxlength="{{maxLengthDesc}}"></textarea>
    <mat-hint align="end">{{ description.value?.length || 0 }}/{{ maxLengthDesc }}</mat-hint>
    <mat-error *ngIf="description.hasError('required')">
      説明文を入力してください。
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>対象店舗</mat-label>
    <textarea matInput [formControl]="objectShop" rows="5"
              maxlength="{{maxLengthOther}}"></textarea>
    <mat-hint align="end">{{ objectShop.value?.length || 0 }}/{{ maxLengthOther }}</mat-hint>
    <mat-error *ngIf="objectShop.hasError('required')">
      対象店舗を入力してください。
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>注意事項</mat-label>
    <textarea matInput [formControl]="notes" rows="5" maxlength="{{maxLengthOther}}"></textarea>
    <mat-hint align="end">{{ notes.value?.length || 0 }}/{{ maxLengthOther }}</mat-hint>
    <mat-error *ngIf="notes.hasError('required')">
      注意事項を入力してください。
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>利用確認文</mat-label>
    <textarea matInput [formControl]="confirmation" rows="5"
              maxlength="{{maxLengthOther}}"></textarea>
    <mat-hint align="end">{{ confirmation.value?.length || 0 }}/{{ maxLengthOther }}</mat-hint>
    <mat-error *ngIf="confirmation.hasError('required')">
      利用確認文を入力してください。
    </mat-error>
  </mat-form-field>

  <section>
    <label>QRコード画像</label>
    <div fxLayout="row wrap" fxLayoutGap="16px" fxLayoutAlign="start end">
      <img class="image-preview" [src]="qrCodeImagePreviewUrl">
      <input #qrCodeImageFile hidden="true" type="file" (change)="onQrCodeImageChanged()"
             onclick="this.value=null"
             accept=".png,.jpg"/>
      <button mat-flat-button color="primary" (click)="qrCodeImageFile.click()">選択</button>
    </div>
  </section>
  <div class="input-datetime">
    <label>有効期限</label>
    <input class="common-timepicker" matInput type="datetime-local" [formControl]="expirationDate" step="1">
  </div>
  <div class="row">
    <div class="input-datetime">
      <label>配布期間(開始)</label>
      <input class="common-timepicker" matInput type="{{getDistributionTermType()}}"
             [formControl]="beginningDistributionTerm" step="1">
    </div>
    <div class="input-datetime">
      <label>配布期間(終了)</label>
      <input class="common-timepicker" matInput type="{{getDistributionTermType()}}"
             [formControl]="endOfDistributionTerm" step="1">
    </div>
  </div>
  <p *ngIf="isAllUserCoupon">※ クーポンは配布期間中の毎朝9時に配布されます。</p>

  <div *ngIf="isAllUserCoupon">
    <label class="subheader">アクティビティ種別</label>
    <div fxLayout="row" fxLayoutGap="32px">
      <mat-checkbox [(ngModel)]="rankingByRunning">Running</mat-checkbox>
      <mat-checkbox [(ngModel)]="rankingByTrailRunning">Trail Running</mat-checkbox>
      <mat-checkbox [(ngModel)]="rankingByCycling">Cycling</mat-checkbox>
      <mat-checkbox [(ngModel)]="rankingByWalking">Walking</mat-checkbox>
      <mat-checkbox [(ngModel)]="rankingByHiking">Hiking</mat-checkbox>
    </div>
  </div>

  <div *ngIf="isAllUserCoupon" class="input-datetime">
    <label>集計対象年月</label>
    <input class="common-timepicker" matInput type="month" [formControl]="targetYearMonth">
  </div>

  <mat-form-field *ngIf="race">
    <mat-label>配布条件</mat-label>
    <mat-select [(ngModel)]="distributionConditionType">
      <ng-container *ngIf="race.race_type === RaceType.NormalRace || race.ranking_method === RaceRankingMethod.RankingByDistance ||
      race.ranking_method === RaceRankingMethod.RankingByDistanceChallenge">
        <mat-option [value]="CouponDistributionConditionType.distance">距離</mat-option>
      </ng-container>
      <ng-container *ngIf="race.ranking_method === RaceRankingMethod.RankingByTime">
        <mat-option [value]="CouponDistributionConditionType.time">タイム</mat-option>
      </ng-container>
      <ng-container *ngIf="race.ranking_method === RaceRankingMethod.RankingByGroupDistance">
        <mat-option [value]="CouponDistributionConditionType.distance">距離</mat-option>
        <mat-option [value]="CouponDistributionConditionType.groupDistance">グループ平均/合計距離</mat-option>
      </ng-container>
      <ng-container *ngIf="race.ranking_method === RaceRankingMethod.RankingByArea">
        <mat-option [value]="CouponDistributionConditionType.area">面積</mat-option>
        <mat-option [value]="CouponDistributionConditionType.specifiedArea">指定エリア到達時</mat-option>
      </ng-container>
      <ng-container *ngIf="race.ranking_method === RaceRankingMethod.RankingByCalorieChallenge">
        <mat-option [value]="CouponDistributionConditionType.calorie">消費カロリー</mat-option>
      </ng-container>
      <ng-container *ngIf="race.ranking_method === RaceRankingMethod.RankingByActivityDays">
        <mat-option [value]="CouponDistributionConditionType.activityDays">達成日数</mat-option>
      </ng-container>
      <!-- TODO ランキング種別を増やした際に対応 -->
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="!isConditionTypeSpecifiedArea()">
    <mat-label>{{ getDistributionCondition() }}</mat-label>
    <input matInput type="number"
           [formControl]="distributionConditionValue">
    <mat-error *ngIf="distributionConditionValue.hasError('required')">
      入力してください。
    </mat-error>
  </mat-form-field>

  <section *ngIf="isConditionTypeSpecifiedArea()">
    <label class="subheader">GeoJSON</label><span>　※Polygon又はMultiPolygonを含んでいること</span>
    <div fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="start">
      <input #geoJSONFile hidden="true" type="file" (change)="onGeoJSONChanged()"
             onclick="this.value=null"
             accept=".json,.geojson"/>
      <div>
        <button mat-flat-button color="primary" (click)="geoJSONFile.click()">選択</button>
      </div>
    </div>
  </section>
  <div #specifiedAreaMap class="map-container" [style]="mapStyle"></div>
  <div *ngIf="specifiedAreaSquareMeter !== undefined && isConditionTypeSpecifiedArea()">
    合計面積: {{ getTotalSquareMeter() }}㎡
  </div>

  <mat-slide-toggle [(ngModel)]="limitEffectiveTime">利用可能時間を設定する</mat-slide-toggle>
  <span class="alert" *ngIf="!limitEffectiveTime">利用時間は無制限になります</span>

  <mat-form-field *ngIf="limitEffectiveTime">
    <mat-label>利用可能時間(分)</mat-label>
    <input matInput type="number" [formControl]="effectiveTime">
    <mat-error *ngIf="effectiveTime.hasError('required')">
      入力してください。
    </mat-error>
    <mat-error *ngIf="effectiveTime.hasError('min')">
      1以上で入力してください。
    </mat-error>
  </mat-form-field>

  <section fxLayout="column" fxLayoutGap="8px">
    <label>プッシュ通知</label>
    <mat-checkbox [(ngModel)]="isPushEnabled">プッシュ通知</mat-checkbox>
    <mat-form-field *ngIf="isPushEnabled">
      <mat-label>プッシュ文言</mat-label>
      <textarea matInput [formControl]="pushNotificationMessage" rows="5"></textarea>
      <mat-hint align="end">{{ pushNotificationMessage.value?.length || 0 }}/100</mat-hint>
    </mat-form-field>
  </section>

  <div class="form-action-container">
    <button mat-raised-button color="primary" (click)="onSubmit()">登録する</button>
  </div>
</div>

